/** A trend line with no axes, scaled to its own min and max. Width follows
 * the container; the last point gets a dot. */
export function Sparkline({
  values,
  color = "var(--ds-s1)",
  height = 28,
  label,
}: {
  values: number[];
  color?: string;
  height?: number;
  label?: string;
}) {
  if (values.length < 2) return null;
  const w = 100;
  const lo = Math.min(...values);
  const hi = Math.max(...values);
  const span = hi - lo || 1;
  const y = (v: number) => 2 + (1 - (v - lo) / span) * (height - 4);
  const pts = values
    .map(
      (v, i) =>
        `${((i / (values.length - 1)) * w).toFixed(2)},${y(v).toFixed(2)}`,
    )
    .join(" ");
  return (
    <svg
      className="ds-spark"
      viewBox={`0 0 ${w} ${height}`}
      preserveAspectRatio="none"
      height={height}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        points={pts}
      />
    </svg>
  );
}
